var module = angular.module('octopusApp.infrastructure');

module.directive('updateWrapper', function () {
  return {
    restrict: 'E',
    replace: false,
    transclude: true,
    scope: {
      busy: '='
    },
    templateUrl: 'infrastructure/directives/views/update-wrapper.html',
    link: function (scope, element) {
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/update_wrapper.js
// module id = 683
// module chunks = 1